import { Close as ResetIcon, Search as SearchIcon } from "@mui/icons-material";
import { Box, IconButton, Stack, TextField } from "@mui/material";
import type { Dayjs } from "dayjs";
import type { FC } from "react";
import MonthPicker from "../components/monthPicker/MonthPicker";
import TagSelect from "../components/tagSelect/TagSelect";
import { useTripTagsByCategory } from "../orders/useTripTagsByCategory";

interface Tag {
  readonly category: string;
  readonly value: string;
}

export interface ECommerceSearchCriteria {
  readonly text: string;
  readonly month: Dayjs;
  readonly tags: Tag[];
  readonly packageOnly?: boolean;
}

interface Props {
  readonly value: ECommerceSearchCriteria;
  readonly onChange: (value: ECommerceSearchCriteria) => void;
  readonly onClear: () => void;
}

const ECommerceSearch: FC<Props> = ({ value, onChange, onClear }) => {
  const { tripTagsByCategory } = useTripTagsByCategory();
  return (
    <Stack
      direction="row"
      spacing={2}
      sx={{
        alignItems: "center",
      }}
    >
      <SearchIcon />
      <Box
        sx={{
          flexBasis: "45%",
        }}
      >
        <TextField
          fullWidth
          value={value.text}
          label="Szukaj"
          onChange={(e) => onChange({ ...value, text: e.target.value })}
        />
      </Box>
      <Box
        sx={{
          flexBasis: "35%",
          height: "100%",
        }}
      >
        <TagSelect
          tags={value.tags}
          availableTags={tripTagsByCategory}
          onChange={(tags) => onChange({ ...value, tags })}
        />
      </Box>
      <Box
        sx={{
          flexBasis: "20%",
        }}
      >
        <MonthPicker
          value={value.month}
          onChange={(month) => {
            if (month) {
              onChange({ ...value, month });
            }
          }}
        />
      </Box>
      <IconButton color="inherit" onClick={onClear}>
        <ResetIcon />
      </IconButton>
    </Stack>
  );
};

export default ECommerceSearch;
